import { ErrorBoundary } from "@sentry/react";
import React, { useCallback, useContext, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { setPageName } from "../../../actions";
import "../../../assets/styles/pages/ignitepdfpage.scss";
import { ErrorMsg } from "../../../components/AppMessages";
import { IframeLayout } from "../../../components/Layouts";
import { IframePageContent } from "../../../components/PageContent";
import { TORCH_RED, WHITE } from "../../../constants";
import { LookStudioEmbeddedLinks } from "../../../constants/globalMSSalesConstants";
import { ThemeContext } from "../../../context";

const IgniteNissanHandbookPdf = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { theme } = useContext(ThemeContext);

  useEffect(() => {
    dispatch(setPageName(""));
  }, [dispatch]);

  const handleClick = () => {
    history.push("/global_ms_sales/ignitems");
  };

  return (
    <IframeLayout hasFilter={true}>
      <ErrorBoundary fallback={<ErrorMsg />}>
        {/* Both children below need to land in .dashboard's single "body" grid cell
                    (main.scss), stacked vertically - this wrapper is the one actual grid item
                    there (see ignitepdfpage.scss), so IframePageContent's own #container (still
                    carrying its usual grid-area: body from pageContainer.scss) just becomes an
                    ordinary nested block instead of a second, overlapping grid item in the same
                    cell. */}
        <div className="ignite_pdf_page_body">
          <div
            className="main_dashboard_ignitepdf"
            style={{
              backgroundColor: theme === "light" ? "#e7ecf0" : "#1a1a1a",
            }}
          >
            <div className="section">
              <div onClick={handleClick} className="back_button" style={{ color: theme === "light" ? TORCH_RED : WHITE }}>
                &lt;
                <span className="back_text">Back</span>
              </div>
            </div>
          </div>
          <IframePageContent frameId="global_ms_sales_ignite_handpdf" iframeUrl={LookStudioEmbeddedLinks.IgniteNissanHandbookPdf} />
        </div>
      </ErrorBoundary>
    </IframeLayout>
  );
};

export default IgniteNissanHandbookPdf;
